import { computed, defineComponent } from 'vue';
import { useStore } from 'vuex';
import { useSweetAlert } from '@/composables/sweetalert';
import { ProjectGetter } from '@/store/project/project.module';
import { CompleteAction } from '@/store/complete/complete.module';
import { Project } from '@/store/project/project.model';

export default defineComponent({
  name: 'ProjectFinishComponent',
  props: {
    projectId: {
      type: Number,
    }
  },
  emits: [
    'refresh'
  ],
  setup: (props, context) => {
    const swal = useSweetAlert();
    const store = useStore();
    const project = computed<Project>(() => store.getters[ProjectGetter.BY_ID](props.projectId));
    const isCompleted = computed(() => project.value?.projectStatus.key >= 5);
    const isCanceled = computed(() => project.value?.isCanceled);
    const isDone = computed(() => project.value?.isDone);
    const isFinished = computed(() => project.value?.isFinished);

    const requestClick = () => {
      swal.confirm('ยื่นคำร้อง!', 'คุณต้องการคำร้องขอจบโครงการใช่หรือไม่?', 'ใช่ ดำเนินการเดี๋ยวนี้!', '#3b7ddd')
        .then((result) => {
          if (result.isConfirmed) {
            store.dispatch(CompleteAction.DONE, { projectId: project.value?.id })
              .then(() => context.emit('refresh'));
          }
        });
    };

    return {
      isCanceled,
      isCompleted,
      isDone,
      isFinished,
      requestClick,
    };
  },
});
